import { Component, Input } from '@angular/core';
import { DataGroupProperty } from '../../../stores/indicatpr-data/indicator-data.widget-selectors';

export interface ChartConfigVisualData {
  focusProperty: DataGroupProperty;
  groupProperty: DataGroupProperty;
  isSingleAxis: boolean;
  isPoiType: boolean;
}

@Component({
  selector: 'app-chart-config-visual',
  standalone: true,
  imports: [],
  templateUrl: './chart-config-visual.component.html',
  styleUrl: './chart-config-visual.component.scss',
})
export class ChartConfigVisualComponent {
  @Input() data!: ChartConfigVisualData;

  getEntityLabel(property: string, single = false): string {
    switch (property) {
      case 'dataLayer':
        return single ? 'Jahr' : 'Jahre';
      case 'indicator':
        return single ? 'Indikator' : 'Indikatoren';
      case 'feature':
        return this.data?.isPoiType
          ? single
            ? 'Standort'
            : 'Standorte'
          : single
            ? 'Teilraum'
            : 'Teilräume';
      default:
        return '';
    }
  }

  getEntityIcon(property: string): string {
    switch (property) {
      case 'dataLayer':
        return 'fas fa-calendar';
      case 'indicator':
        return 'fas fa-ruler-combined';
      case 'feature':
        return this.data?.isPoiType
          ? 'fas fa-map-location-dot'
          : 'fas fa-circle-nodes';
      default:
        return '';
    }
  }

  getFocusLabel(icon = false): string {
    if (icon) {
      return this.getEntityIcon(this.data.focusProperty);
    } else {
      return this.getEntityLabel(this.data.focusProperty, true);
    }
  }

  getGroupLabel(icon = false): string {
    if (icon) {
      return this.getEntityIcon(this.data.groupProperty);
    } else {
      return this.getEntityLabel(this.data.groupProperty);
    }
  }

  getRemainingLabel(icon = false): string {
    const all = ['dataLayer', 'indicator', 'feature'];
    const remaining = all.find(
      item =>
        item !== this.data.focusProperty && item !== this.data.groupProperty
    );

    if (icon) {
      return remaining ? this.getEntityIcon(remaining) : '';
    } else {
      return remaining ? this.getEntityLabel(remaining) : '';
    }
  }
}
